import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { LuCalendarDays } from "react-icons/lu";
import Card from 'react-bootstrap/Card';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import api from '../../services/api';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Loader from '../../components/Loader';
import Shimmer from '../../components/Shimmer';

import LanguageContext from '../../contexts/language';

import Base from '../../assets/images/base-news.png';

export default function Events() {

    const { language } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    
    const { url } = useParams();

    const [news, setNews] = useState([]);
    const [items, setItems] = useState([]);

    async function loadNews(){
        setLoading(true);
        try{
            const response = await api.post(`/posts-event`);
            setNews(response.data.content.news);
            setLoading(false);
        }catch(err){
            setLoading(false);
        }
    }

    async function loadNew(){

        setLoading(true);
        try{
            const response = await api.post(`/post?url=${url}`);
            setNews(response.data.content.news[0]);
            setItems(response.data.content.news[0].post_items ? response.data.content.news[0].post_items : []);
            setLoading(false);
        }catch(err){
            setLoading(false);
        }
    }

    useEffect(() => {
        if(url=='' || url==null){
            loadNews();
        }else{
            loadNew();
        }
    }, [url]);

    return (
        <div className="page">
            <Header />
            {loading ?
            <Loader />:
            <>
                {url=='' || url==null ?
                <div className="full mt-30 mb-40 form">
                    <h3 className="title_b mb-20">
                        {language.menu_eventos}
                    </h3>
                    {news=='' ?
                    <div className="row w-100">
                        <div className="col-md-12 m-auto text text-center">
                            <h4 className="mb-0"><strong>{lang==='pt' ? 'EM BREVE' : 'COMING SOON'}</strong></h4>
                        </div>
                    </div>:
                    <>
                        {Array.isArray(news) &&
                        <div className="container">
                            <div className="row w-100 d-flex justify-content-center gh-4 gv-4 news">
                                {news.map((item, index) => (
                                <div key={item.id} className="col-12 col-sm-6 col-lg-4">
                                    <Link to={`/evento/${item.url}`}>
                                        <Card>
                                            <img src={Base} className="card-img-top" style={{backgroundImage: `url(${lang==='pt' ? item.image : item.image_en})`}} />
                                            <Card.Body>
                                                <Card.Title className="mb-0">{lang==='pt' ? item.title : item.title_en}</Card.Title>
                                            </Card.Body>
                                        </Card>
                                    </Link>
                                </div>))}
                            </div>
                        </div>}
                    </>}
                </div>:
                <div className="full mt-30 mb-40 form">
                    {news!='' &&
                    <div className="container">
                        <div className="row w-100 gh-4 gv-4 news">
                            <div className="col-12 col-sm-12 col-lg-10 m-auto">
                                <h3 className="title_b text-center mb-20">
                                    {lang==='pt' ? news.title : news.title_en}
                                </h3>
                            </div>
                            <div className="col-12 col-sm-12 col-lg-10 m-auto">
                                {items.map((item, index) => (
                                <div key={`content-${index}`}>
                                    {item.type==='image' &&
                                    <div className="mb-20">
                                        <img src={item.image} className="news-image" />
                                    </div>}
                                    {item.type==='text' &&
                                    <div className="news-text mb-20" dangerouslySetInnerHTML={{__html: lang==='pt' ? item.text : item.text_en}} />}
                                    {item.type==='video' &&
                                    <div className="mb-20">
                                        <div className="video-container">
                                            {
                                            item.video_type==='vimeo' ?
                                            <iframe src={`https://player.vimeo.com/video/${item.video}?title=0&byline=0&portrait=0`} frameBorder="0" allowFullScreen></iframe>:
                                            <iframe src={`https://www.youtube.com/embed/${item.video}?rel=0&showinfo=0`} frameBorder="0" allowFullScreen></iframe>
                                            }
                                        </div>
                                    </div>}
                                    {item.type==='pdf' &&
                                    <div className="mb-20">
                                        <div className="pdf-container">
                                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                                <Viewer fileUrl={lang==='pt' ? item.file : item.file_en} defaultScale="PageWidth" />
                                            </Worker>
                                        </div>
                                    </div>}
                                </div>))}
                            </div>
                        </div>
                    </div>}
                </div>}
            </>}
            <Footer />
        </div>
    );
}
